import { render } from "./Game.vue?vue&type=template&id=05f6509b&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=05f6509b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-05f6509b"

export default script